import { createSlice } from "@reduxjs/toolkit"

export const vendorOrderSlice = createSlice({
    name: 'vendorOrderSlice',
    initialState: { data: '' },
    reducers: {
        setRowData: (state, action) => {
            state.data = action.payload
        },
        initRowData: (state, action) => {
            state.data = ''
        }
    }
})

export const { setRowData, initRowData } = vendorOrderSlice.actions

export default vendorOrderSlice.reducer